import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, ITravelItems } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

function VisaPrepAdditionalHistoryStep8Info(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  const renderTravelDetails = () => {
    const allTravelDetails: React.ReactNode[] = [];
    if (props.travelItems && props.travelItems.length) {
      props.travelItems.forEach((travelDetail: ITravelItems, i: number) => {
        allTravelDetails.push(
          <SummaryGroup title={t('forms.visa:travelDetails', { i: i + 1 })} key={`travel-details-${i}`}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRAVEL_DETAILS_COUNTRY}-${i}`}
              label={t('forms.visa:country')}
              value={travelDetail.country}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRAVEL_DETAILS_REASON}-${i}`}
              label={t('forms.visa:reasonForTravel')}
              value={travelDetail.reason}
            />
            {travelDetail.reason === 'Other - provide details' ? (
              <SummaryRow
                className={'visa-summary'}
                key={`${VQ.TRAVEL_DETAILS_REASON_OTHER}-${i}`}
                label={t('forms.visa:reasonForTravelOther')}
                value={travelDetail.reasonOther}
              />
            ) : null}
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRAVEL_DETAILS_ENTRY_DATE}-${i}`}
              label={t('forms.visa:entryDate')}
              fullLabel={'When did you enter this country?'}
              value={travelDetail.entryDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRAVEL_DETAILS_EXIT_DATE}-${i}`}
              label={t('forms.visa:exitDate')}
              fullLabel={'When did you leave this country?'}
              value={travelDetail.exitDate}
            />
          </SummaryGroup>,
        );
      });
    }
    return allTravelDetails;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_TRAVELLED}
        label={t('forms.visa:hasTravelledOutsideResidence')}
        fullLabel={'Have you ever travelled outside your country of residence, excluding the UK, in the last 10 years?'}
        value={boolToYesNo(props.hasTravelled)}
      />
      {props.hasTravelled ? (
        <>
          <SummaryRow className={'visa-summary'} label={t('forms.visa:howManyTimes2')} value={props.travelItems?.length} />

          <Box as="ol" pl={8} key={'travel-details'}>
            {renderTravelDetails()}
          </Box>
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalHistoryStep8Info;
